// extracted by mini-css-extract-plugin
module.exports = {"Tags":"style_Tags__3ZDbj","Tag":"style_Tag__AMTBt"};